import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  root: {
    position: 'fixed',
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1400,
    padding: theme.spacing(1, 2, 2),
    pointerEvents: 'none',
  },
  panel: {
    pointerEvents: 'auto',
    margin: '0 auto',
    maxWidth: 720,
    padding: theme.spacing(2.5, 3),
    borderRadius: theme.shape.borderRadius * 2,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.common.white,
    boxShadow: theme.shadows[8],
  },
  title: {
    margin: 0,
    fontSize: '1.125rem',
    fontWeight: 700,
    color: theme.palette.text.primary,
  },
  description: {
    margin: theme.spacing(1, 0, 0),
    fontSize: '0.875rem',
    color: theme.palette.text.secondary,
  },
  privacy: {
    margin: theme.spacing(1, 0, 0),
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
    '& a': {
      fontWeight: 600,
      color: theme.palette.primary.main,
    },
  },
  actions: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
    },
  },
  settings: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1.5),
  },
  row: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.grey[50],
  },
  rowText: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.25),
  },
  rowTitle: {
    fontSize: '0.875rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
  },
  rowDescription: {
    fontSize: '0.75rem',
    color: theme.palette.text.secondary,
  },
}));

export default useStyles;
